// Generated by Melange


function make(param) {
  return {
    baseById: new Map(),
    detailsById: new Map(),
    infoById: new Map(),
    songIdsById: new Map()
  };
}

export {
  make,
}
/* No side effect */
